export default __webpack_public_path__ + "static/newsletter-man-in-suit-488ebd9daae1956f427543048fe1346d.png";